import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { Subscriptions } from '@chemist2u/types-client/C2U/ParseObjects';
import { addIcons } from 'ionicons';
import { accessibilityOutline, arrowForwardOutline } from 'ionicons/icons';
import { AddressType, PlaceAutocompleteResult } from '@googlemaps/google-maps-services-js';

@Component({
    selector: 'app-program-card',
    templateUrl: './program-card.component.html',
    styleUrls: ['./program-card.component.scss'],
    providers: [CurrencyPipe],
    imports: [CommonModule, IonIcon]
})
export class ProgramCardComponent {
  public program = input.required<Subscriptions>();
  public manage = output();

  public paymentError = signal<boolean>(false);

  constructor() {
    addIcons({ accessibilityOutline, arrowForwardOutline });
  }

  public formattedDate = computed<string>(() => {
    return this.program().nextTriggerDate ? this.formatDateWithOrdinal(this.program().nextTriggerDate!) : "";
  });

  public formattedAddress = computed<string>(() => {
    const placeDetails = this.program().deliveryAddress;
    if (!placeDetails?.address?.address_components) return "";
    const addressComponents = placeDetails.address.address_components;
    const streetNumber = addressComponents.find(comp => comp.types.includes(AddressType.street_number))?.long_name || '';
    const route = addressComponents.find(comp => comp.types.includes(AddressType.route))?.long_name || '';
    const aptSuiteFloor = placeDetails.aptSuiteFloor;
    return aptSuiteFloor ? `${aptSuiteFloor}/${streetNumber} ${route}` : (placeDetails.selectedAddress as PlaceAutocompleteResult).structured_formatting.main_text;
  });

  private formatDateWithOrdinal(date: Date): string {
    if (!date || !(date instanceof Date)) {
      throw new Error('Invalid date object');
    }
  
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
  
    const suffix = this.getOrdinalSuffix(day);
  
    return `${day}${suffix} ${month}`;
  }
  
  private getOrdinalSuffix(day: number): string {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  public onManageProgram() {
    this.manage.emit();
  }
}